import {observer} from 'mobx-react';
import {TimeTrackingSubnav} from 'main/containers/time_tracking';
import ShiftScheduler from './ShiftScheduler';

const ShiftSchedulerContainer = observer(({scope}) => {
  return (
    <div>
      <TimeTrackingSubnav scope={scope}/>
      <ShiftScheduler/>
    </div>
  );
});

export default ShiftSchedulerContainer;
